var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComputerWithRing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 21.81,
    viewBox: "0 0 36 21.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-3 {\n        fill: #527991;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3580",
    "data-name": "Rectangle 3580",
    className: "cls-1",
    width: 36,
    height: 21.81
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4399",
    "data-name": "Group 4399",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4398",
    "data-name": "Group 4398",
    className: "cls-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3951",
    "data-name": "Path 3951",
    className: "cls-3",
    d: "M32.051,0H5.525a.616.616,0,0,0-.651.574V19.1H32.7V.574A.616.616,0,0,0,32.051,0M18.767.965a.363.363,0,1,1-.364.363.363.363,0,0,1,.364-.363M30.353,17.141H7.223V2.628h23.13Z",
    transform: "translate(-0.788 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3952",
    "data-name": "Path 3952",
    className: "cls-3",
    d: "M22.259,23.564c0,.607-.5.814-1.1.814H14.845c-.607,0-1.1-.207-1.1-.814H.511a.5.5,0,0,0-.5.57c.111.737.439.52.947,1.076a1.263,1.263,0,0,0,.935.412H34.112a1.261,1.261,0,0,0,.935-.412c.508-.557.836-.339.947-1.076a.5.5,0,0,0-.5-.57Z",
    transform: "translate(0 -3.813)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3953",
    "data-name": "Path 3953",
    className: "cls-3",
    d: "M25.106,8.526,24.765,7.7l.853-.642a6.469,6.469,0,0,0-1.906-1.913l-.645.852L22.24,5.65l-.827-.344.15-1.06A6.5,6.5,0,0,0,20.2,4.1a6.427,6.427,0,0,0-1.341.142l.147,1.06-.828.342-.828.342-.642-.853A6.479,6.479,0,0,0,14.8,7.039l.852.645-.344.827-.345.827-1.06-.15a6.4,6.4,0,0,0-.005,2.7l1.061-.147.341.828.342.829-.853.641a6.469,6.469,0,0,0,1.906,1.913l.645-.852.827.345.827.344-.15,1.06A6.5,6.5,0,0,0,20.2,17a6.427,6.427,0,0,0,1.341-.142l-.147-1.06.828-.342.828-.341.642.852a6.479,6.479,0,0,0,1.913-1.906l-.852-.645.344-.827.345-.827,1.06.15a6.4,6.4,0,0,0,.005-2.7l-1.061.147Zm-4.9,6.012a3.99,3.99,0,1,1,3.99-3.99,3.99,3.99,0,0,1-3.99,3.99",
    transform: "translate(-2.224 -0.663)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputerWithRing);
export default __webpack_public_path__ + "static/media/computerWithRing.2fd9829d.svg";
export { ForwardRef as ReactComponent };